import React from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core/react/i18n';

type Props = {
	translationKey: TranslationKey | null | undefined;
};

export function InputError({ translationKey }: Props): React.JSX.Element | null {
	const { translate } = useI18n();

	if (!translationKey) return null;

	return <span role="alert">{translate(translationKey)}</span>;
}
